import React from 'react';
import { browserHistory } from 'react-router';
import XpressTemplateKioskTable from '../XpressTemplateKioskTable';
import Api from '../../Api';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import XpressTemplateAppliedModal from '../XpressTemplateAppliedModal';
import XpressTemplateView from '../XpressTemplateView';

const kioskTableWidth = 1000;
const kioskTableHeight = 350;

class XpressTemplateApplyPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      template: {},
      rows: [],
      filteredRows: [],
      clickedRows: [],
      appliedTemplate: false,
      showTemplateViewModal: false,
    };

    this.onFilterChange = this.onFilterChange.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleApplyClick = this.handleApplyClick.bind(this);
    this.goToTemplateList = this.goToTemplateList.bind(this);
    this.handleShowTemplateViewModal = this.handleShowTemplateViewModal.bind(this);
    this.handleHideTemplateViewModal = this.handleHideTemplateViewModal.bind(this);
  }

  componentDidMount() {
    let { params } = this.props;

    Api.getXTemplate(params.id).then((data) => {
      this.setState({ template: data });
    });

    Api.getKioskList('name, getlocname(location), getorgname(org)').then((data) => {
      let kiosklist = data.map((kiosk) => {
        return {
          org: kiosk['getorgname(org)'],
          location: kiosk['getlocname(location)'],
          kiosk: kiosk.name,
        };
      });
      this.setState({ rows: kiosklist, filteredRows: kiosklist });
    });
  }

  handleSubmit() {
    this.goToTemplateList();
  }

  goToTemplateList() {
    browserHistory.push({ pathname: '/admin/xpresstemplates' });
  }

  onFilterChange(e) {
    let filterBy = e.target.value.trim().toUpperCase();
    let searchedRows = [];

    for (let kioskRow of this.state.rows) {
      let filterTermMatched = false;

      let kiosk = kioskRow.kiosk || '';
      let location = kioskRow.location || '';
      let org = kioskRow.org || '';

      if (
        kiosk.toUpperCase().includes(filterBy) ||
        location.toUpperCase().includes(filterBy) ||
        org.toUpperCase().includes(filterBy)
      ) {
        filterTermMatched = true;
      }

      if (filterTermMatched) {
        searchedRows.push(kioskRow);
      }
    }

    this.setState({
      filteredRows: searchedRows,
    });
  }

  handleRowClick(event, index) {
    let clickedRows = this.state.clickedRows;
    let clickedRow = this.state.filteredRows[index];

    if (!clickedRows.includes(clickedRow)) {
      clickedRows.push(clickedRow);
    }

    this.setState({
      clickedRows: clickedRows,
    });
  }

  handleClear() {
    this.setState({
      clickedRows: [],
    });
  }

  handleApplyClick() {
    let clickedRows = this.state.clickedRows;
    let templateId = this.state.template.id;
    let templateName = this.state.template.name;

    if (clickedRows.length === 0) {
      alert('No kiosk selected');
      return;
    }

    let applyPromiseList = [];
    for (let kioskRow of clickedRows) {
      applyPromiseList.push(Api.applyXTemplate(kioskRow.kiosk, templateId));
    }

    Promise.all(applyPromiseList)
      .then(() => {
        this.setState({ appliedTemplate: true });
      })
      .catch((args) => {
        console.error(args);
        alert('Error in applying template: ' + templateName);
      });
  }

  handleShowTemplateViewModal() {
    this.setState({ showTemplateViewModal: true });
  }

  handleHideTemplateViewModal() {
    this.setState({ showTemplateViewModal: false });
  }

  render() {
    let barColor = '#216887';
    let { template, showTemplateViewModal, appliedTemplate, clickedRows, filteredRows } =
      this.state;

    if (appliedTemplate) {
      return (
        <ModalContainer>
          <ModalDialog>
            <XpressTemplateAppliedModal
              {...this.props}
              template={template}
              kiosks={clickedRows}
              onClickOk={this.goToTemplateList}
            />
          </ModalDialog>
        </ModalContainer>
      );
    } else {
      return (
        <div className='xtemplate-page'>
          {showTemplateViewModal && (
            <ModalContainer onClose={this.handleHideTemplateViewModal}>
              <ModalDialog onClose={this.handleHideTemplateViewModal}>
                <XpressTemplateView template={template} />
              </ModalDialog>
            </ModalContainer>
          )}
          <div className='title-row page-title'>
            <div
              className='title-back cursor-pointer'
              onClick={this.goToTemplateList}
              style={{ background: barColor }}
            >
              <i className='fa fa-chevron-left' style={{ background: barColor }} />
            </div>
            <div className='title' style={{ paddingLeft: '10px', background: barColor }}>
              Apply Template
            </div>
          </div>
          <div style={{ width: kioskTableWidth }}>
            <h2>
              <a href='javascript:void(0)' onClick={this.handleShowTemplateViewModal}>
                {template.name}
              </a>
            </h2>
            <div style={{ margin: '10px 0' }}>
              <input
                style={{ height: 30, width: 250 }}
                type='text'
                onChange={this.onFilterChange}
                placeholder='Search for Org Location Kiosk'
              />
            </div>

            <div
              className='title'
              style={{
                paddingLeft: '10px',
                width: 1000,
                background: barColor,
              }}
            >
              Choose Kiosks
            </div>
            <XpressTemplateKioskTable
              onRowClick={this.handleRowClick}
              rowsCount={filteredRows.length}
              rowHeight={50}
              headerHeight={50}
              width={kioskTableWidth}
              height={kioskTableHeight}
              rows={filteredRows}
            />

            <br />

            <div>
              <div
                className='title'
                style={{
                  paddingLeft: '10px',
                  width: 1000,
                  background: barColor,
                }}
              >
                Apply To Kiosks
              </div>
              <XpressTemplateKioskTable
                onRowClick={() => {}}
                rowsCount={clickedRows.length}
                rowHeight={50}
                headerHeight={50}
                width={kioskTableWidth}
                height={kioskTableHeight}
                rows={clickedRows}
              />

              <div style={{ background: '#FFFFF', width: '1000px', height: '30px', marginTop: 20 }}>
                <button
                  style={{ float: 'right', background: barColor }}
                  className='pure-button pure-button-primary'
                  onClick={this.handleApplyClick}
                >
                  Apply to Kiosks
                </button>
                <button
                  style={{
                    margin: '0 10px',
                    float: 'right',
                    background: barColor,
                  }}
                  className='pure-button pure-button-primary'
                  onClick={this.handleClear}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default XpressTemplateApplyPage;



// WEBPACK FOOTER //
// ./src/components/pages/XpressTemplateApplyPage.js